'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable max-depth, max-statements, complexity, max-lines-per-function */
var SLASH = 47;
var DOT = 46;

var assertPath = function assertPath(path) {
  var t = typeof path === 'undefined' ? 'undefined' : _typeof(path);
  if (t !== 'string') {
    throw new TypeError('Expected a string, got a ' + t);
  }
};

// this function is directly from node source
var posixNormalize = function posixNormalize(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code = void 0;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length) code = path.charCodeAt(i);else if (code === SLASH) break;else code = SLASH;
    if (code === SLASH) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== DOT || res.charCodeAt(res.length - 2) !== DOT) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0) res += '/..';else res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0) {
          res += '/' + path.slice(lastSlash + 1, i);
        } else {
          res = path.slice(lastSlash + 1, i);
        }
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === DOT && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }

  return res;
};

var decode = function decode(s) {
  try {
    return decodeURIComponent(s);
  } catch (_) {
    return s;
  }
};

var normalize = function normalize(p) {
  assertPath(p);

  var path = p;
  if (path.length === 0) return '.';

  var isAbsolute = path.charCodeAt(0) === SLASH;
  var trailingSeparator = path.charCodeAt(path.length - 1) === SLASH;

  path = decode(path);
  path = posixNormalize(path, !isAbsolute);

  if (path.length === 0 && !isAbsolute) path = '.';
  if (path.length > 0 && trailingSeparator) path += '/';
  if (isAbsolute) return '/' + path;

  return path;
};

exports.default = normalize;
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./node_modules/path-normalize/lib/index.js
// module id = 200
// module chunks = 0